import { render, staticRenderFns } from "./FormatXMLString.vue?vue&type=template&id=01e2e968&scoped=true"
import script from "./FormatXMLString.vue?vue&type=script&lang=js"
export * from "./FormatXMLString.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e2e968",
  null
  
)

export default component.exports